import React from "react";
import "../styles/Achievements.css";
import { motion } from "framer-motion";
import { achievements } from "./constants";

function Achievements() {
  return (
    <motion.div
      className="achievements__main page"
      variants={{
        hidden: { opacity: 0, y: 75 },
        visible: { opacity: 1, y: 0 },
      }}
      initial="hidden"
      animate="visible"
      transition={{ duration: 0.5, delay: 0.25 }}
    >
      <h1 className="page-heading">Achievements</h1>
      <p className="page-subtitle">
        Awards, competitive programming, and community contributions
      </p>

      <div className="achievements__grid">
        {achievements.map((item) => (
          <div className="achievement__card" key={item.title}>
            <h2>{item.title}</h2>
            <p>{item.description}</p>
            {item.link && (
              <a href={item.link} rel="noreferrer" target="_blank">
                View profile →
              </a>
            )}
          </div>
        ))}
      </div>
    </motion.div>
  );
}

export default Achievements;
